import { useEffect, useMemo, useState } from "react";
import { fetchRoles } from "../../lib/api";
import { SelectField } from "./Field";

export const useRoles = () => {
  const [departments, setDepartments] = useState([]);
  useEffect(() => {
    fetchRoles().then(setDepartments).catch(() => setDepartments([]));
  }, []);
  return departments;
};

export const RolePicker = ({ prefix, department, jobRole, onChange, roleLabel = "Job Role" }) => {
  const departments = useRoles();
  const deptOptions = useMemo(() => departments.map((d) => ({ value: d.value, label: d.label })), [departments]);
  const roleOptions = useMemo(() => {
    const found = departments.find((d) => d.value === department);
    return found ? found.roles.map((r) => ({ value: r, label: r })) : [];
  }, [departments, department]);

  return (
    <>
      <SelectField label="Department" value={department} onChange={(v) => onChange(v, "")} options={deptOptions}
        placeholder={departments.length ? "Select department" : "Loading..."} testId={`${prefix}-select-department`} />
      <SelectField key={department || "none"} label={roleLabel} value={jobRole} onChange={(v) => onChange(department, v)}
        options={roleOptions} placeholder={department ? `Select role (${roleOptions.length})` : "Select department first"}
        testId={`${prefix}-select-job-role`} disabled={!department} />
    </>
  );
};
